import { createSelector } from '@/factory'
import { constants } from './dropdown.constant'

const getHandlers = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.handler }, true)
const getContent = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.content }, true)

export const dropDownSelectors = {
	getHandlers,
	getContent,
}
